var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("收件信息")))])]), _vm.mailingInfo.consigneeInfo ? _c("a-form", {
    staticClass: "consignee-form",
    attrs: {
      form: _vm.mailingInfo.consigneeInfo,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("姓名")
    }
  }, [_vm._v(_vm._s(_vm.mailingInfo.consigneeInfo.name))]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("电话")
    }
  }, [_vm._v(_vm._s(_vm.mailingInfo.consigneeInfo.mobile))]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("详细地址")
    }
  }, [_vm._v(_vm._s(_vm.mailingInfo.consigneeInfo.address))])], 1) : _vm._e(), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("寄件信息")))])]), _c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("物流公司")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.mailingInfo.logisticsCompany,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "logisticsCompany", $$v);
      },
      expression: "mailingInfo.logisticsCompany"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("运单号")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.mailingInfo.shipmentNum,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "shipmentNum", $$v);
      },
      expression: "mailingInfo.shipmentNum"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };